<template>
  <div
    class="tag"
    :style="`background-color: ${tagColor(tag)}`"
  >
    {{ tag.text }}
  </div>
</template>

<script>
export default {
  name: 'Tag',
  props: {
    tag: {
      type: Object,
      required: true,
    },
  },
  methods: {
    tagColor(tag) {
      if (tag.refPath && (tag.refPath.startsWith('/organizations') || tag.refPath.startsWith('organizations'))) {
        return '#FFEFAF';
      }

      return '#AFE1FF';
    },
  },
};
</script>

<style scoped>
.tag {
  padding: 0 6px;
  font-size: 12px;
  font-weight: 500;
  height: 24px;
  line-height: 24px;
  border-radius: 4px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
